// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__uZnqS","footer":"ModalCreateQualiphyProcedure_footer__1O-kI","additionData":"ModalCreateQualiphyProcedure_additionData__339GY"};